<script lang="ts">
    import {generateMockSegmentedData} from './mock-data';
    import KpSegmentedColumnChart from 'shared/components/kp-charts/KpSegmentedColumnChart.svelte';
    import OptimisationOverviewContainer from './components/OptimisationOverviewContainer.svelte';
    import OptimisationOverviewHeading from './components/OptimisationOverviewHeading.svelte';
</script>

<OptimisationOverviewContainer>
    <OptimisationOverviewHeading heading="Předávací protokol" printButtonLabel="Tisk předávacího protokolu"/>

    <KpSegmentedColumnChart height="275px" data="{generateMockSegmentedData()}"/>
</OptimisationOverviewContainer>